import { createApp } from 'vue';
import * as Sentry from '@sentry/vue';

// ponytail: crypto.randomUUID absent in older mobile WebKit (DDG browser, iOS < 15.4)
if (!crypto.randomUUID) {
  crypto.randomUUID = () =>
    ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
}
import { createI18n } from 'vue-i18n';
import './assets/shared.css';
import App from './App.vue';
import { router } from './router/index.js';
import { registerSW } from 'virtual:pwa-register';
import en from './locales/en.js';
import es from './locales/es.js';

registerSW({ immediate: true });

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') ?? 'en',
  fallbackLocale: 'en',
  messages: { en, es },
});

const app = createApp(App).use(router).use(i18n);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration({ router })],
  tracesSampleRate: 0.2,
  // Zero-knowledge: no user PII, no request bodies
  sendDefaultPii: false,
});

if (import.meta.env.DEV) {
  const { VueAxe, VueAxePopup } = await import('vue-axe');
  app.use(VueAxe);
  app.component('VueAxePopup', VueAxePopup);
}

app.mount('#app');
